export default "__VITE_ASSET__BgDmgoPk__"